import {OLVIDO_PASS_TYPES} from '../constants/olvidoPass.types'
import {OlvidoPass} from '../interfaces/olvidoPass.interface'

export const olvidoPassInitialState: OlvidoPass = {
  formRestablecer: {
    tipo: OLVIDO_PASS_TYPES.INPUT_EMAIL,
    email: '',
    telefono: '',
    error: '',
  },
  formVerificar: {
    code: '',
    error: '',
  },
  formPassword: {
    passwd: '',
    passwd2: '',
  },
  errorFormPassword: {
    passwd: '',
    passwd2: '',
  },
}
